<script setup lang="ts">
import { computed } from 'vue'

import DeckPlayerProgressBar from '../../components/DeckPlayerProgressBar.vue'
import { useDeckPlayerStore } from '../../store/useDeckPlayerStore'

const props = defineProps<{
  deckId: string
  fallbackTotal?: number
}>()

const store = useDeckPlayerStore()
const session = computed(() => store.getSession(props.deckId))

const total = computed(() => session.value?.total ?? props.fallbackTotal ?? 0)
const completed = computed(() => (session.value ? Object.keys(session.value.doneIds).length : 0))
</script>

<template>
  <DeckPlayerProgressBar :completed="completed" :total="total" />
</template>
